import { render } from "./FormCadastrarPublicidade.vue?vue&type=template&id=b5f2cb82&scoped=true"
import script from "./FormCadastrarPublicidade.vue?vue&type=script&lang=js"
export * from "./FormCadastrarPublicidade.vue?vue&type=script&lang=js"

import "./FormCadastrarPublicidade.vue?vue&type=style&index=0&id=b5f2cb82&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f2cb82"]])

export default __exports__